import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { SetlistEditor } from "../components/SetlistEditor";
import { useSession } from "../lib/auth";
import { songsQuery } from "../lib/queries";
import { useSignInRedirect } from "../lib/useSignInRedirect";

export function SetlistNew() {
  const { session, isLoading: sessionLoading } = useSession();
  const signInRedirect = useSignInRedirect();

  const {
    data: songs,
    isLoading: songsLoading,
    error,
  } = useQuery({
    ...songsQuery(),
    enabled: !!session?.user,
  });

  if (sessionLoading) {
    return <div className="text-text-muted">Loading...</div>;
  }

  if (!session?.user) {
    return (
      <div>
        <p className="mb-4 text-text-muted">
          You need to sign in to create a setlist.
        </p>
        <button
          type="button"
          onClick={() => signInRedirect("/setlists/new")}
          className="text-amber hover:underline"
        >
          Sign In
        </button>
      </div>
    );
  }

  if (songsLoading) {
    return <div className="text-text-muted">Loading songs...</div>;
  }

  if (error) {
    return (
      <div>
        <p className="text-red-muted">Failed to load songs</p>
        <Link to="/setlists" className="text-amber hover:underline">
          Back to setlists
        </Link>
      </div>
    );
  }

  return <SetlistEditor mode="create" allSongs={songs ?? []} />;
}
